export const environment = {
  production: true,
  baseUrl: 'https://webapi.qnbfaktoring.com.tr/api/'
};
